import { render, staticRenderFns } from "./ShuttleBusList.vue?vue&type=template&id=bd66fb4e&scoped=true&"
import script from "./ShuttleBusList.vue?vue&type=script&lang=js&"
export * from "./ShuttleBusList.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleBusList.vue?vue&type=style&index=0&id=bd66fb4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd66fb4e",
  null
  
)

export default component.exports